import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, ResourceLoaderParams, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { PanelModule } from 'primeng/panel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';
import { catchError, from, map, mergeMap, of, toArray } from 'rxjs';
import { Asset } from '../../../../generated/generated-types';
import { AssetService } from '../../../asset/services/asset.service';
import { IPopOverViewMode } from '../pop-over-panel-widget/interfaces-types';
import { PopOverCommonService } from '../pop-over-panel-widget/pop-over-common.service';

@Component({
  selector: 'app-assets-panel-view',
  templateUrl: './assets-panel-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    TooltipModule,
    PanelModule,
    ScrollPanelModule,
    MenuModule
  ]
})
export class AssetsPanelViewComponent implements IPopOverViewMode {
  protected assetService = inject(AssetService);
  protected popOverCommonService = inject(PopOverCommonService);

  assetsIds = input.required<string[]>();
  assetsResource = rxResource<Asset[], string[]>({
    params: () => {
      return this.assetsIds();
    },
    stream: ({ params }: ResourceLoaderParams<string[]>) => {
      return from(params).pipe(
        mergeMap(id => this.assetService.getAsset(id).single$),
        map(query => query.asset),
        toArray(),
        catchError(error => {
          console.error('Error loading assets, It might have been deleted:', error);
          return of([] as Asset[]);
        })
      );
    }
  });
  menuItems = signal<MenuItem[]>([]);

  menuItemsFactory() {
    this.popOverCommonService.menuItemsFactory(this.menuItems, this.assetsResource);
  }

  async downloadAssets(id: string): Promise<void> {
    await this.popOverCommonService.downloadAssets(id, this.assetsResource);
  }

  isImageFileByExtension(filename: string): boolean {
    return this.popOverCommonService.isImageFileByExtension(filename);
  }

}
